<template>
  <div>
    <v-row>
      <!-- <v-col cols="12" md="3" sm="12">
        <v-card class="mt-4 mx-auto card-chart" max-width="400" elevation="0">
          <v-card-text class="pt-0">
            <div class="text-h6 font-weight-light mb-2">
              Visitantes: {{ qtyVisitorEscort[0] }}
            </div>
            <div class="subheading font-weight-light"></div>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small> mdi-clock </v-icon>
            <span class="text-caption grey--text font-weight-light"
              >Hoje</span
            >
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" sm="12">
        <v-card class="mt-4 mx-auto card-chart" max-width="400" elevation="0">
          <v-card-text class="pt-0">
            <div class="text-h6 font-weight-light mb-2">
              Acompanhantes: {{ qtyVisitorEscort[1] }}
            </div>
            <div class="subheading font-weight-light"></div>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small> mdi-clock </v-icon>
            <span class="text-caption grey--text font-weight-light"
              >Hoje</span
            >
          </v-card-text>
        </v-card>
      </v-col> -->
      <!-- <v-col cols="12" md="2" sm="12">
        <v-card
          class="mt-4 w-full h-full card-chart "
          style=""
          elevation="10"
          @click="$router.push('/PesquisarMovi')"
        >
          <v-card-text class="pt-0">
            <div class="text-h6 white--text mb-2">
              Visitantes registrados hoje: {{ qtyVisitorEscort[2] }}
            </div>
            <v-divider class="my-2" color="#699ac9"></v-divider>
            <div class="flex flex-nowrap">
              <v-icon class="mr-2" small style="color: aliceblue;"> mdi-clock </v-icon>
            <span class="white--text text-xs font-weight-light">Atualizado hoje: {{ hour }}</span>
            </div>
            
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="2" sm="12">
        <v-card 
          class="mt-4 w-full h-full card-chart"
          elevation="10"
          @click="$router.push('/PesquisarMovi')"
        >
          <v-card-text class="pt-0">
            <div class="text-h6 white--text mb-2">
              Acompanhantes registrados hoje: {{ qtyVisitorEscort[3] }}
            </div>
            <div class="subheading font-weight-light"></div>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small style="color: aliceblue;"> mdi-clock </v-icon>
            <span class="white--text text-xs font-weight-light text-sm">Atualizado hoje: {{ hour }}</span>
          </v-card-text>
        </v-card>
      </v-col> -->
      <v-col cols="12" md="4" sm="6" lg="2" xl="2">
        <!-- class="mx-auto"
        max-width="364" -->
        <v-card
          class="equal-card"
          elevation="6"
          @click="$router.push('/person')"
        >
          <v-img src="@/assets/pictures/card2.png" height="200px" cover />

          <v-card-title
            style="
              display: flex;
              text-align: center;
              font-size: 16px;
              word-break: normal;
              overflow: hidden;
              word-wrap:break-word;
              white-space: normal; 
              padding:9px;
              /* text-overflow: ellipsis;
               */
            "
          >
            CADASTRAR VISITANTE/ ACOMPANHANTE
          </v-card-title>
        </v-card>
      </v-col>
      <v-col ols="12" md="4" sm="6" lg="2">
        <v-card
          class="equal-card"
          elevation="6"
          @click="$router.push('/adm-person')"
        >
          <v-img src="@/assets/pictures/card1.png" height="200px" center />

          <v-card-title
            style="
              text-align: center;
              font-size: 16px;
              word-break: normal;
              overflow: hidden;
              text-overflow: ellipsis;
              padding:9px;
            "
          >
            CADASTRAR VISITANTE ADMINISTRATIVO
          </v-card-title>
        </v-card>
      </v-col>
      <v-col
        ols="12"
        md="4"
        sm="6"
        lg="2"
        xl="2"
        v-if="$store.state.authUser.id_profile_user !== '3'"
      >
        <v-card 
          class="equal-card"
          elevation="6"
          @click="$router.push('/users')"
        >
          <v-img src="@/assets/pictures/card3.png" height="200px" center />

          <v-card-title
            style="
              text-align: center;
              font-size: 16px;
              word-break: normal;
              overflow: hidden;
              text-overflow: ellipsis;
               padding:9px;
            "
          >
            CADASTRAR USUÁRIO DO SISTEMA
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import axios from "@/axios";
import { mapActions } from "vuex";
import { visitorsMixin } from "../../mixins/visitorsMixin";

export default {
  mixins: [visitorsMixin],
  data: () => ({
    value: "",
    qtyVisitorEscort: [],
    type: "bar",
    hour: "",
    options: {
      chart: {
        id: "relatorio-dashboard",
      },
      xaxis: {
        categories: [
          "Visitante(s)",
          "Acompanhante(s)",
          "Visitante/dia",
          "Acompanhante/dia",
        ],
      },
    },
    series: [
      {
        name: "Quantidade",
        data: [],
      },
    ],
  }),
  methods: {
    ...mapActions(["fetchLookupsDefault"]),
    updateCharts() {
      this.series = [
        {
          data: this.qtyVisitorEscort,
        },
      ];
    },

    getFormattedTime() {
      const date = new Date();
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    },
  },
  async created() {
    this.fetchLookupsDefault();
    // await axios.get("/dashboard").then((e) => {
    //   this.qtyVisitorEscort = [
    //     e.data.qty_visitor,
    //     e.data.qty_escort,
    //     e.data.visitor_on_day,
    //     e.data.escort_on_day,
    //   ];
    //   this.updateCharts();
    // });
  },

  mounted() {
    this.hour = this.getFormattedTime();
  },
};
</script>

<style>

.equal-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 320px;
  max-width: 370px;
  width: 100%;
  margin: 0 auto;

  
}
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.card-chart {
  border: 2px solid #cfcccc !important;
  border-radius: 10px !important;
  background-color: #326ca5 !important;
  padding: 10px;
  transition: all 0.1s ease-in-out;
}
.card-chart:hover {
  background-color: #1c4477 !important;
  transform: scale(1.02);
}

/* @media (min-width: 1200px) and (max-width: 1440px) {
  .card-texto {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
} */
</style>
